const ENTER_KEY = 'Enter';

export const handleEnterKeyDown = (e, callback) => {
  if (e.key === ENTER_KEY) {
    callback();
  }
};
